import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { BasicModule } from "../app/basic/basic.module";
import { HttpClientModule } from "@angular/common/http";
import { ServiceWorkerModule } from "@angular/service-worker";
import { environment } from "../environments/environment";
import { ApiService } from "./services/api.service";
import { NgxsModule } from "@ngxs/store";
import { UserState } from "./states/user.state";
import { NgxsLoggerPluginModule } from "@ngxs/logger-plugin";
import { NgxsStoragePluginModule } from "@ngxs/storage-plugin";
import {
  NgxsRouterPluginModule,
  RouterStateSerializer,
} from "@ngxs/router-plugin";
import { AngularFireModule } from "@angular/fire/compat";
import { AngularFireStorageModule } from "@angular/fire/compat/storage";
import { NgxsReduxDevtoolsPluginModule } from "@ngxs/devtools-plugin";
import { FormsModule } from "@angular/forms";
import { FcmService } from "./services/fcm.service";
import { AngularFireMessagingModule } from "@angular/fire/compat/messaging";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatToolbarModule } from "@angular/material/toolbar";
import { AngularFirestoreModule } from "@angular/fire/compat/firestore";
import { AngularFirePerformanceModule } from "@angular/fire/compat/performance";
import { AngularFireAuthModule } from "@angular/fire/compat/auth";
import { UIState } from "./states/ui.state";
import { LocationService } from "./services/location.service";
import { RichTextEditorModule } from "@syncfusion/ej2-angular-richtexteditor";
import { GraphQLModule } from "./apollo-clients-module";
import { MatIconModule } from "@angular/material/icon";
import { MatSidenavModule } from "@angular/material/sidenav";
import { CustomRouterStateSerializer } from "./customRouterStateSerializer";
import { MAT_SELECT_SCROLL_STRATEGY_PROVIDER } from "@angular/material/select";
import { MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY_PROVIDER } from "@angular/material/tooltip";
import { CookieService } from "ngx-cookie-service";
import { provideFirebaseApp } from "@angular/fire/app";
import { initializeApp } from "firebase/app";
import { provideAuth, getAuth } from "@angular/fire/auth";
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    BasicModule,
    HttpClientModule,
    ServiceWorkerModule.register("ngsw-worker.js", {
      enabled: environment.production,
    }),
    FormsModule,
    NgxsModule.forRoot([UserState, UIState]),
    NgxsLoggerPluginModule.forRoot({ disabled: environment.production }),
    NgxsStoragePluginModule.forRoot({
      key: ["user"],
    }),
    NgxsRouterPluginModule.forRoot(),
    NgxsReduxDevtoolsPluginModule.forRoot(),
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireStorageModule,
    AngularFireMessagingModule,
    MatSnackBarModule,
    MatToolbarModule,
    AngularFirePerformanceModule,
    AngularFireAuthModule,
    RichTextEditorModule,
    AngularFirestoreModule,
    MatSidenavModule,
    MatIconModule,
    GraphQLModule,
  ],
  providers: [
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    LocationService,
    CookieService,
    ApiService,
    FcmService,
    { provide: RouterStateSerializer, useClass: CustomRouterStateSerializer },
    MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY_PROVIDER,
    MAT_SELECT_SCROLL_STRATEGY_PROVIDER,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
